import NetworkHandler from 'utils/network';
import config from 'config';

function updateTransportOrderItSummaryDetails(body) {
    return NetworkHandler.put(`${config.getUrl('shipping_order')}/it-summary-details`, body);
}
function getTransportOrderItSummaryDetails(params) {
    return NetworkHandler.get(`${config.getUrl('shipping_order')}/it-summary-details`, {
        params: params,
    });
}

// Lệnh vận chuyển
function getTransportOrders(body) {
    return NetworkHandler.post(`${config.getUrl('transport_orders')}/fetch-transport-orders`, {
        ...body,
    });
}
function createTransportOrders(body) {
    return NetworkHandler.put(`${config.getUrl('transport_orders')}/create-transport-orders`, body);
}

function getFindTransportOrders(type, body) {
    return NetworkHandler.post(`${config.getUrl('transport_orders')}/${type}/find-transport-orders`, {
        ...body,
    });
}

function updateTransportOrders(body) {
    return NetworkHandler.put(`${config.getUrl('transport_orders')}/update-transport-orders`, body);
}

function historyTransportOrders(params) {
    return NetworkHandler.get(`${config.getUrl('transport_orders')}/history`, {
        params: params,
    });
}

function confirmTransportOrders(type, body) {
    return NetworkHandler.put(`${config.getUrl('transport_orders')}/${type}/confirm-transport-orders`, body);
}

// dùng để get list file của bước thu ngân xác nhận
function getFileTransportOrders(params) {
    return NetworkHandler.get(`${config.getUrl('transport_orders')}/get-file`, {
        params: params,
    });
}

// dùng để xóa file của bước thu ngân xác nhận
function deleteFileTransportOrders(id) {
    return NetworkHandler.delete(`${config.getUrl('transport_orders')}/delete-file/${id}`);
}

// upload file
function uploadFileTransportOrders(body) {
    return NetworkHandler.put(`${config.getUrl('transport_orders')}/upload-file`, body);
}

// Lệnh vận chuyển điện tử
function getTransportOrdersElec(params) {
    return NetworkHandler.get(`${config.getUrl('shipping_order')}/summary`, {
        params: params,
    });
}

function summaryConfirmEnd(id) {
    return NetworkHandler.post(`${config.getUrl('shipping_order')}/summary/confirm-end/${id}`);
}
function summaryResign(body) {
    return NetworkHandler.post(`${config.getUrl('shipping_order')}/summary/re-sign`, {
        ...body,
    });
}
function summaryResend(body) {
    return NetworkHandler.post(`${config.getUrl('shipping_order')}/summary/re-send`, {
        ...body,
    });
}
// Chi tiết lệnh vận chuyển điện tử
function detailsResend(body) {
    return NetworkHandler.post(`${config.getUrl('shipping_order')}/detail/re-send`, {
        ...body,
    });
}
function detailsResign(body) {
    return NetworkHandler.post(`${config.getUrl('shipping_order')}/detail/re-sign`, {
        ...body,
    });
}

function detailsSave(body) {
    return NetworkHandler.put(`${config.getUrl('shipping_order')}/detail`, {
        ...body,
    });
}

function details(params) {
    return NetworkHandler.get(`${config.getUrl('shipping_order')}/detail`, {
        params: params,
    });
}

function detailHistory(params) {
    return NetworkHandler.get(`${config.getUrl('shipping_order')}/detail/history`, {
        params: params,
    });
}

function getInfoTemplate(params) {
    return NetworkHandler.get(
        `${config.getUrl('template_transport_order')}`,
        {
            params: params,
        },
        'none',
    );
}

function getReport(params) {
    return NetworkHandler.get(`${config.getUrl('shipping_order')}/summary/report`, {
        params: params,
    });
}
function getReportTransportOrderElect(params) {
    return NetworkHandler.get(`${config.getUrl('shipping_order')}/detail/inspection/report`, {
        params: params,
    });
}
function operatorConfirm(id) {
    return NetworkHandler.post(`${config.getUrl('shipping_order')}/summary/operator-confirm/${id}`);
}
function confirmAccepted(body) {
    return NetworkHandler.post(`${config.getUrl('shipping_order')}/confirm-accepted`, body);
}
function previewPDF(params) {
    return NetworkHandler.get(`${config.getUrl('shipping_order')}/summary/preview`, {
        params: params,
    });
}

function refreshPdfLink(params) {
    return NetworkHandler.get(`${config.getUrl('shipping_order')}/summary/refresh-link`, {
        params: params,
    });
}

function updateTransportOrdersElecIT(body) {
    return NetworkHandler.put(`${config.getUrl('shipping_order')}/it-summary`, body);
}
// Đồng bộ sản lượng vé (sync)
function syncTicketQuantity(body) {
    return NetworkHandler.put(`${config.getUrl('shipping_order')}/detail/sync`, body);
}

export default {
    getTransportOrders,
    createTransportOrders,
    getFindTransportOrders,
    updateTransportOrders,
    historyTransportOrders,
    confirmTransportOrders,
    getFileTransportOrders,
    deleteFileTransportOrders,
    uploadFileTransportOrders,
    getTransportOrdersElec,
    detailsResend,
    detailsResign,
    summaryConfirmEnd,
    summaryResign,
    summaryResend,
    detailsSave,
    details,
    detailHistory,
    getInfoTemplate,
    getReport,
    getReportTransportOrderElect,
    operatorConfirm,
    confirmAccepted,
    previewPDF,
    refreshPdfLink,
    updateTransportOrdersElecIT,
    getTransportOrderItSummaryDetails,
    updateTransportOrderItSummaryDetails,
    syncTicketQuantity,
};
